module.exports = __webpack_public_path__ + "img/931.428d486c.png";